module.exports = __webpack_public_path__ + "_/img/MapMarker5_Red.7ea37528.svg";